import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Teams from "./components/Team";


const ClientTeams = ({clientId}) => {
	
	useEffect(() => {
	}, [clientId]);

	return (
		
	    <div>
			<Teams clientId={clientId}/>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  	  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ClientTeams);